import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class HeadOffice extends ShadowDOMElement {
	static className = "HeadOffice";
	
	static properties = {
		rcs: {type: Boolean, attribute: "rcs", reflect: true},
		converter: {
			fromAttribute: (value) => value === "true",
			toAttribute: (value) => (value ? "true" : "false"), 
		},
		lrcs: {type: Boolean, attribute: "lrcs", reflect: true},
		converter: {
			fromAttribute: (value) => value === "true",
			toAttribute: (value) => (value ? "true" : "false"), 
		},
		adresseTitle : { type: String, attribute: "adresse-title"} 
	};

	constructor() {
		super();
		this.rcs = false;
		this.lrcs = false;
		this.adresseTitle = "Adresse *";
	}

	render() {
    return html`
      <title-field label="Siège social"></title-field>
      <row-wrapper>
        <text-field label="${this.adresseTitle}" required name="address"></text-field>
      </row-wrapper>
      <autocomplete-ville></autocomplete-ville>
      ${this.rcs
        ? html`
            <rcs-number-field label="Numéro de RCS *" required></rcs-number-field>
          `
        : ""}
	${this.lrcs
	  ? html`
	      <row-with-tooltip tooltip-text="Ville d'immatriculation" >
	        <text-field label="Lieu d'immatriculation (RCS) *" required name="registration_location"></text-field>
	      </row-wrapper>
	    `
	  : ""}
    `;
	}
	
	isTransient (){
		return false;
	}
}

customElements.define("head-office", HeadOffice);
